import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    style: { "height": "70px" },
    class: "w-full items-center justify-center flex space-x-5"
};
const _hoisted_2 = { class: "flex flex-row items-center justify-center space-x-1 text-gray-700" };
import { flipCoordinates } from '@/compositions/useFlipCoordinates';
import { getHistoryObject } from '@/compositions/useHistoryHelper';
import { rotateAroundCenter } from '@/compositions/useRotation';
import { useHistoryStore } from '@/store/history';
import { HistoryType } from '@/types/history';
import { Tools } from '@/types/tools';
import { CheckIcon, Reflect01Icon, RefreshCcw01Icon, RefreshCw01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UITooltip, UIButton, UITextSmNormal } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CropSubTool',
    props: {
        stage: {
            type: Object,
            require: true,
        },
        baseImage: {
            type: Object,
            require: true,
        },
        selectedOption: {
            type: String,
            require: true,
        },
        cropChanges: {
            type: Boolean,
            require: true,
        },
        filterChanges: {
            type: Boolean,
            require: true,
        },
        adjustmentChanges: {
            type: Boolean,
            require: true,
        },
        disableAction: {
            type: Boolean,
            require: true,
        },
    },
    emits: ['apply'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const historyStore = useHistoryStore();
        const flipOrRotateChange = ref(false);
        const beforeObject = ref({});
        const afterObject = ref({});
        function flip(direction) {
            if (props.disableAction)
                return;
            beforeObject.value = getHistoryObject(Tools.CROP, props.baseImage, HistoryType.UPDATE);
            flipObject(direction);
            afterObject.value = getHistoryObject(Tools.CROP, props.baseImage, HistoryType.UPDATE);
            setHistory();
        }
        function flipObject(direction) {
            let direct = direction;
            const rotation = props.baseImage.rotation();
            if ((rotation / 2) % 2 !== 0) {
                direct = direction == 'h' ? 'v' : 'h';
            }
            if (direct === 'h') {
                const scaleX = -1 * props.baseImage.scaleX();
                const { x, y } = flipCoordinates(direct, props.baseImage, {
                    x: scaleX,
                    y: props.baseImage.scaleY(),
                });
                props.baseImage.setAttrs({ scaleX: scaleX, x, y });
            }
            else if (direct === 'v') {
                const scaleY = -1 * props.baseImage.scaleY();
                const { x, y } = flipCoordinates(direct, props.baseImage, {
                    x: props.baseImage.scaleX(),
                    y: scaleY,
                });
                props.baseImage.setAttrs({ scaleY: scaleY, x, y });
            }
            flipOrRotateChange.value = true;
        }
        function getShapeCoordinates(scaleX, scaleY) {
            let x = props.baseImage.x();
            let y = props.baseImage.y();
            const rotation = props.baseImage.rotation();
            const scale = {
                x: scaleX,
                y: scaleY,
            };
            if (props.baseImage.scaleX() === -1) {
                scale.x = 1;
            }
            if (props.baseImage.scaleY() === -1) {
                scale.y = 1;
            }
            const flipData = flipCoordinates('b', props.baseImage, scale);
            if (props.baseImage.scaleX() === -1) {
                if ((rotation / 2) % 2 !== 0) {
                    y = flipData.y;
                }
                else {
                    x = flipData.x;
                }
            }
            if (props.baseImage.scaleY() === -1) {
                if ((rotation / 2) % 2 !== 0) {
                    x = flipData.x;
                }
                else {
                    y = flipData.y;
                }
            }
            return { x, y };
        }
        function rotateObject(angle) {
            if (props.disableAction)
                return;
            beforeObject.value = getHistoryObject(Tools.CROP, props.baseImage, HistoryType.UPDATE);
            const scaleX = props.baseImage.scaleX();
            const scaleY = props.baseImage.scaleY();
            const { x, y } = getShapeCoordinates(scaleX, scaleY);
            const attrs = {
                x,
                y,
                width: props.baseImage.width(),
                height: props.baseImage.height(),
                rotation: props.baseImage.rotation(),
            };
            const rotatedAttrs = rotateAroundCenter(attrs, angle);
            if (Math.abs(rotatedAttrs.rotation) === 360) {
                rotatedAttrs.rotation = 0;
                rotatedAttrs.x = props.stage.width() / 2 - props.baseImage.width() / 2;
                rotatedAttrs.y = props.stage.height() / 2 - props.baseImage.height() / 2;
            }
            props.baseImage.setAttrs(rotatedAttrs);
            let direction;
            if (scaleX === -1) {
                direction = 'h';
                if ((props.baseImage.rotation() / 2) % 2 !== 0)
                    direction = 'v';
                flipObject(direction);
            }
            if (scaleY === -1) {
                direction = 'v';
                if ((props.baseImage.rotation() / 2) % 2 !== 0)
                    direction = 'h';
                flipObject(direction);
            }
            flipOrRotateChange.value = true;
            afterObject.value = getHistoryObject(Tools.CROP, props.baseImage, HistoryType.UPDATE);
            setHistory();
        }
        // function reset() {
        //   if (props.selectedOption === Tools.CROP) flipOrRotateChange.value = false
        //   emits('reset', props.selectedOption)
        // }
        function apply() {
            if (props.disableAction)
                return;
            emits('apply', props.selectedOption);
        }
        function setHistory() {
            const id = props.baseImage.id();
            historyStore.setHistory(id, Tools.CROP, beforeObject.value, afterObject.value, HistoryType.UPDATE);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UIButton), {
                    id: "ghl-image-editor-flip-horizontal",
                    type: "default",
                    size: "medium",
                    quaternary: true,
                    circle: true,
                    text: false,
                    onClick: _cache[0] || (_cache[0] = ($event) => (flip('h'))),
                    class: "w-8 h-8 flex justify-center"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(UITooltip), null, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(Reflect01Icon), { class: "w-5 h-5 text-gray-700" })
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.flipHorizontal')), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_unref(UIButton), {
                    id: "ghl-image-editor-flip-vertical",
                    type: "default",
                    size: "medium",
                    quaternary: true,
                    circle: true,
                    text: false,
                    onClick: _cache[1] || (_cache[1] = ($event) => (flip('v'))),
                    class: "w-8 h-8 flex justify-center"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(UITooltip), null, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(Reflect01Icon), {
                                    class: "w-5 h-5 text-gray-700",
                                    style: { "transform": "rotate(90deg)" }
                                })
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.flipVertical')), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_unref(UIButton), {
                    id: "ghl-image-editor-rotate-clockwise",
                    type: "default",
                    size: "medium",
                    quaternary: true,
                    circle: true,
                    text: false,
                    onClick: _cache[2] || (_cache[2] = ($event) => (rotateObject(90))),
                    class: "w-8 h-8 flex justify-center"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(UITooltip), null, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(RefreshCw01Icon), { class: "w-5 h-5 text-gray-700" })
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.rotateClockwise')), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_unref(UIButton), {
                    id: "ghl-image-editor-rotate-anticlockwise",
                    type: "default",
                    size: "medium",
                    quaternary: true,
                    circle: true,
                    text: false,
                    onClick: _cache[3] || (_cache[3] = ($event) => (rotateObject(-90))),
                    class: "w-8 h-8 flex justify-center"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(UITooltip), null, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(RefreshCcw01Icon), { class: "w-5 h-5 text-gray-700" })
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.rotateAntiClockwise')), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_unref(UIButton), {
                    id: "ghl-image-editor-rotate-crop-apply",
                    type: "default",
                    size: "medium",
                    quaternary: true,
                    circle: true,
                    text: true,
                    onClick: _cache[4] || (_cache[4] = ($event) => (apply())),
                    class: "w-16 h-8 flex justify-center"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(CheckIcon), { class: "w-5 h-5" }),
                            _createVNode(_unref(UITextSmNormal), null, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.apply')), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
